<template lang="pug">
.d-flex
  .flex-grow-1
    filter-phone.mr-2(ref="phone" :filter.sync="phoneFilter" check-initial-value)
    filter-name.mr-2(ref="name" :filter.sync="nameFilter" check-initial-value)
    filter-progress.mr-2(ref="progress" :filter.sync="nameFilter" :type="type" check-initial-value)
    filter-amount.mr-2(ref="sales" :filter.sync="salesFilter" title="Current sales" param="total_spend")
  v-btn.button-sm.underline.px-0(text :disabled="allFilters.length === 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterPhone from '@/components/clinic/patient/filters/FilterPhone.vue'
import FilterProgress from '@/components/clinic/marketing/filters/FilterProgress.vue'
import FilterAmount from '@/components/module/filter/FilterAmount.vue'

export default {
  components: { FilterName,  FilterPhone, FilterProgress, FilterAmount },
  props: ['filters', 'propFilters', 'type'],
  data: () => ({
    key: 0,
    nameFilter: {},
    phoneFilter: {},
    progressFilter: {},
    salesFilter: {},
  }),
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.phoneFilter.key) {
        filters.push(this.phoneFilter)
      }
      if (this.progressFilter.key) {
        if (this.progressFilter.key === 'between') {
          const values = this.progressFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.progressFilter)
        }
      }
      if (this.salesFilter.key) {
        if (this.salesFilter.key === 'between') {
          const values = this.salesFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.salesFilter)
        }
      }

      return filters
    },
    dataFilters () {
      return {
        nameFilter: this.nameFilter,
        phoneFilter: this.phoneFilter,
        progressFilter: this.progressFilter,
        salesFilter: this.salesFilter,
      }
    }
  },
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  methods: {
    setFilters () {
      this.nameFilter = this.propFilters?.nameFilter || {}
      this.phoneFilter = this.propFilters?.phoneFilter || {}
      this.progressFilter = this.propFilters?.progressFilter || {}
      this.salesFilter = this.propFilters?.salesFilter || {}
      this.$nextTick(() => {
        this.$refs.name.setData()
        this.$refs.phone.setData()
        this.$refs.progress.setData()
        this.$refs.sales.setData()
      })
    },
    resetFilters () {
      this.nameFilter = {}
      this.phoneFilter = {}
      this.progressFilter = {}
      this.salesFilter = {}
    },
  }
}
</script>